<script>
  // "katexify" function
  import { gdBias, gdWeight } from "../data-store";
  import katexify from "../katexify";
  import GradientDescentScatterplot from "./GradientDescentScatterplot.svelte";
  import GradientDescentErrorPlot from "./GradientDescentErrorPlot.svelte";

  // math equations
  const math1 = "ax^2+bx+c=0";

  // instantiate class for gd methods
  let gdScatterClass;
  let gdErrorClass;
  let shown;
  let show;
</script>
<div id="gd-container">
  <div id="charts-container">
    <div id="gd-chart-regression">
      <GradientDescentScatterplot bind:this={gdScatterClass} />
    </div>
    <div id="gd-chart-error">
      <GradientDescentErrorPlot bind:this={gdErrorClass} />
    </div>
  </div>
  <div id="equations-container">
    <div id="buttons-container">
      <button on:click={() => gdScatterClass.runGradientDescent(1)}
        >1 Step</button
      >
      <button on:click={() => gdScatterClass.runGradientDescent(5)}
        >5 Steps</button
      >
      <button on:click={() => gdScatterClass.runGradientDescent(10)}
        >10 Steps</button
      >
      <button on:click={() => gdScatterClass.runGradientDescent(25)}
        >25 Steps</button
      >
    </div>
    <div id="weight-slider">
      <div class="input-container">
        <label for="slider1" class="float-left">
          <span class="bold">Weight:</span>
          {$gdWeight}
        </label>
        <input
          type="range"
          min="-3"
          max="3"
          step=".01"
          bind:value={$gdWeight}
          class="slider"
          id="slider1"
        />
      </div>
    </div>
    <div id="bias-slider">
      <div class="input-container">
        <label for="slider2" class="float-left">
          <span class="bold">Bias:</span>
          {$gdBias}
        </label>

        <input
          type="range"
          min="-50"
          step="-1"
          max="10"
          bind:value={$gdBias}
          class="slider"
          id="slider2"
        />
      </div>
    </div>
    <div id="equation-math">
      <div class="input-container">
        <label for="equation-math" class="float-left"
          ><span class="bold">Our Model: </span></label
        >
        {@html katexify(
          `\\begin{aligned} P(y=1|x) = \\frac{1}{1 + e^{-(${$gdBias}${
            $gdWeight < 0 ? "" : "+"
          }
            ${$gdWeight}x)}} \\end{aligned}`
        )}
      </div>
    </div>
  </div>
</div>
<br /><br />

<style>
  #gd-container {
    display: grid;
    grid-template-rows: 1fr auto;
    font-family: var(--font-main);
    margin: auto;
    max-width: 1000px;
    width: 100%;
    height: auto;
    min-height: 65vh;
  }

  #equations-container {
    text-align: left;
    flex-direction: column;
    justify-content: center;
  }

  #equation-math {
    color: var(--squidink);
    justify-content: center;
  }

  #buttons-container {
    display: flex;
    margin: 8px auto;
    justify-content: space-around;
    align-items: center;
    width: 90%;
  }

  .input-container {
    display: flex;
    flex-direction: row;
    margin: 8px auto;
    justify-content: space-around;
    align-items: center;
    width: 70%;
  }

  button {
    background-color: var(--secondary); /* Green */
    border: none;
    color: var(--paper);
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 4px 2px;
    cursor: pointer;
    opacity: 0.9;
  }

  button:hover {
    outline: 2px solid var(--squidink);
  }

  button:active {
    color: var(--squidink);
  }

  button:visited {
    color: var(--white);
  }

  button.show-button {
    background-color: var(--bg); /* Green */
    border: none;
    color: var(--squidink);
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 4px 2px;
    cursor: pointer;
    outline: 2px solid var(--squidink);
  }

  .show-button-container {
    max-width: var(--max-width);
    display: flex;
    margin: 1rem auto;
    justify-content: center;
  }

  #charts-container {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 100%;
    height: 100%;
    padding-right: 1rem;
    max-height: 350px;
  }

  #gd-chart-regression {
    width: 100%;
    height: 100%;
    min-width: 300px;
  }

  #gd-chart-error {
    width: 100%;
    height: 100%;
    min-width: 300px;
  }

  .slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 6px;
    border-radius: 999px;
    background: var(--paper);
    outline: none;
    opacity: 1;
    transition: opacity 0.2s, box-shadow 0.15s, transform 0.15s;
    cursor: pointer;
  }

  .slider::-webkit-slider-runnable-track {
    height: 6px;
    background: linear-gradient(90deg, var(--secondary) 0%, var(--paper) 100%);
    border-radius: 999px;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    margin-top: -6px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--secondary);
    border: 2px solid var(--squidink);
    box-shadow: 0 2px 6px rgba(0,0,0,0.12);
    transition: transform 0.12s ease, box-shadow 0.12s ease;
  }

  .slider:focus::-webkit-slider-thumb {
    transform: scale(1.08);
    box-shadow: 0 4px 12px rgba(0,0,0,0.18);
  }

  .slider::-moz-range-track {
    height: 6px;
    background: linear-gradient(90deg, var(--secondary) 0%, var(--paper) 100%);
    border-radius: 999px;
  }

  .slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--secondary);
    border: 2px solid var(--squidink);
  }

  @media (prefers-color-scheme: dark) {
    .slider {
      background: var(--squidink);
    }
    .slider::-webkit-slider-runnable-track,
    .slider::-moz-range-track {
      background: linear-gradient(90deg, var(--paper) 0%, var(--bg) 100%);
    }
    .slider::-webkit-slider-thumb,
    .slider::-moz-range-thumb {
      background: var(--bg);
      border-color: var(--paper);
    }
  }

  label {
    width: 100%;
    color: var(--squidink);
  }

  /* mobile */
  @media screen and (max-width: 950px) {
    #gd-container {
      grid-template-rows: auto auto;
      max-width: 100%;
      width: 100%;
      height: auto;
      min-height: 80vh;
      max-height: none;
    }

    #charts-container {
      max-width: 100%;
      grid-template-columns: 100%;
      grid-template-rows: 50% 50%;
    }
  }
</style>
